if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = evt.submitter || this.querySelector('[type="submit"]');

      // formData object created to check whether multiple items are being added to a cart, else use the standard single item request
      const formData = new FormData(this.querySelector('form'));
      console.log(formData.has("items[0][id]"));
      // if multiple
      if(formData.has("items[0][id]")) {
        this.multipleItemRequestHandler(formData, submitButton);
      }
      //else single
      else{
        this.singleItemRequestHandler(submitButton);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    // Keeps the visible submit control in sync when mobile uses its fixed bar.
    setSubmitButtonLoading(submitButton, isLoading) {
      if (!submitButton) return;

      if (isLoading) {
        submitButton.setAttribute('aria-disabled', true);
      } else {
        submitButton.removeAttribute('aria-disabled');
      }
      submitButton.classList.toggle('loading', isLoading);

      const mobileStickyAtc = submitButton.closest('mobile-sticky-atc');
      if (mobileStickyAtc) {
        mobileStickyAtc.classList.toggle('is-loading', isLoading);
      }
    }

    multipleItemRequestHandler(formData, submitButton = this.querySelector('[type="submit"]')) {
      
      if (!submitButton || submitButton.classList.contains('loading')) return;
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.setSubmitButtonLoading(submitButton, true);

      const items = [];
      // console.log(formData.get("items[0][id]"));
      // for (const key of formData.keys()) {
      //   console.log(key);
      // }

      // Manually construct the items array from the form data
      let currentItem = {};
      for (const [name, value] of formData.entries()) {
        // console.log([name, value]);
        if (name.startsWith('items[')) {
          if (name.includes('[id]')) {
            currentItem.id = value;
          } else if (name.includes('[quantity]')) {
            currentItem.quantity = parseInt(value, 10);
          }

          if (currentItem.id && currentItem.quantity > 0) { // Only add if ID and valid quantity exist
            items.push(currentItem);
            currentItem = {}; // Reset for the next item
          }
        }
      }

      const sectionId = window.systemPackagesSectionId;
      // console.log('Section ID from global variable:', sectionId);
      // Use sectionId as needed
    

      //console.log(items);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({items: items, 
        'section-id': sectionId,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      console.log(config.body);
      if (items.length > 0) {
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          console.log(response);
          this.cartNotification.renderMultiItemContents(response);
        })
        .catch((e) => {
          console.error(e);
          
        })
        .finally(() => {
          this.setSubmitButtonLoading(submitButton, false);
        });
      } else {
        this.setSubmitButtonLoading(submitButton, false);
      }
    }

    //handles single item requests
    singleItemRequestHandler(submitButton = this.querySelector('[type="submit"]')) {
      if (!submitButton || submitButton.classList.contains('loading')) return;
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.setSubmitButtonLoading(submitButton, true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        this.cartNotification.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.setSubmitButtonLoading(submitButton, false);
      });
    }
  });
}

if (!customElements.get('mobile-sticky-atc')) {
  customElements.define('mobile-sticky-atc', class MobileStickyAtc extends HTMLElement {
    constructor() {
      super();

      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onQuantityInput = this.onQuantityInput.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.onSourceQuantityChange = this.onSourceQuantityChange.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.syncSubmitState = this.syncSubmitState.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      this.fallbackTrigger = this.querySelector('[data-mobile-sticky-atc-trigger]');
      this.quantityInput = this.querySelector('[data-mobile-sticky-atc-quantity]');
      this.minusButton = this.querySelector('[data-mobile-sticky-atc-minus]');
      this.plusButton = this.querySelector('[data-mobile-sticky-atc-plus]');
      this.submitButton = this.querySelector('[data-mobile-sticky-atc-submit]');
      this.bar = this.querySelector('.mobile-sticky-atc__bar');
      this.addLabel = this.querySelector('[data-mobile-sticky-atc-add-label]');
      this.statusLabel = this.querySelector('[data-mobile-sticky-atc-status-label]');
      this.sourceQuantityInput = this.findSourceQuantityInput();
      this.sourceSubmitButton = this.form.querySelector('.product-form__submit[name="add"]');

      if (!this.fallbackTrigger || !this.quantityInput || !this.submitButton || !this.bar || !this.addLabel || !this.statusLabel) return;

      if (this.sourceQuantityInput) {
        this.quantityInput.min = this.sourceQuantityInput.min || '1';
        if (this.sourceQuantityInput.max) this.quantityInput.max = this.sourceQuantityInput.max;
        this.quantityInput.value = this.sourceQuantityInput.value || '1';
        this.sourceQuantityInput.addEventListener('input', this.onSourceQuantityChange);
        this.sourceQuantityInput.addEventListener('change', this.onSourceQuantityChange);
      }

      this.quantityInput.addEventListener('input', this.onQuantityInput);
      this.quantityInput.addEventListener('change', this.onQuantityChange);
      if (this.minusButton) this.minusButton.addEventListener('click', () => this.stepQuantity(-1));
      if (this.plusButton) this.plusButton.addEventListener('click', () => this.stepQuantity(1));
      this.form.addEventListener('submit', this.onFormSubmit, true);

      if (this.sourceSubmitButton) {
        this.submitObserver = new MutationObserver(this.syncSubmitState);
        this.submitObserver.observe(this.sourceSubmitButton, {
          attributes: true,
          childList: true,
          subtree: true
        });
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.onMediaChange);
      } else {
        this.mediaQuery.addListener(this.onMediaChange);
      }

      this.syncQuantityFromSource();
      this.syncSubmitState();
      this.updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.quantityInput) this.quantityInput.removeEventListener('input', this.onQuantityInput);
      if (this.quantityInput) this.quantityInput.removeEventListener('change', this.onQuantityChange);
      if (this.sourceQuantityInput) this.sourceQuantityInput.removeEventListener('input', this.onSourceQuantityChange);
      if (this.sourceQuantityInput) this.sourceQuantityInput.removeEventListener('change', this.onSourceQuantityChange);
      if (this.form) this.form.removeEventListener('submit', this.onFormSubmit, true);
      if (this.submitObserver) this.submitObserver.disconnect();

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
      } else {
        this.mediaQuery.removeListener(this.onMediaChange);
      }

      this.updatePageState();
    }

    findSourceQuantityInput() {
      const sectionQuantityInput = document.getElementById(`Quantity-${this.dataset.sectionId}`);
      if (sectionQuantityInput) return sectionQuantityInput;

      const formId = this.form.id.replace(/"/g, '\\"');
      return document.querySelector(`[form="${formId}"][name="quantity"], [form="${formId}"][name="items[0][quantity]"]`)
        || this.form.querySelector('input[name="quantity"], input[name="items[0][quantity]"]');
    }

    findVisibilityTrigger() {
      return this.form;
    }

    getMinimumQuantity() {
      return Math.max(1, parseInt(this.quantityInput.min || (this.sourceQuantityInput && this.sourceQuantityInput.min) || '1', 10) || 1);
    }

    getMaximumQuantity() {
      const max = parseInt(this.quantityInput.max || (this.sourceQuantityInput && this.sourceQuantityInput.max) || '', 10);
      return Number.isNaN(max) ? null : max;
    }

    normalizeQuantity(value, fallback = this.getMinimumQuantity()) {
      const parsedValue = parseInt(value, 10);
      let quantity = Number.isNaN(parsedValue) ? fallback : parsedValue;
      const min = this.getMinimumQuantity();
      const max = this.getMaximumQuantity();

      quantity = Math.max(min, quantity);
      if (max !== null) quantity = Math.min(max, quantity);

      return quantity;
    }

    setQuantity(value, dispatchChange = true) {
      const quantity = this.normalizeQuantity(value);
      this.quantityInput.value = quantity;
      this.updateQuantityWidth();

      if (this.sourceQuantityInput && this.sourceQuantityInput.value !== String(quantity)) {
        this.sourceQuantityInput.value = quantity;
        this.sourceQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        if (dispatchChange) {
          this.sourceQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    stepQuantity(delta) {
      const currentValue = this.quantityInput.value || (this.sourceQuantityInput && this.sourceQuantityInput.value);
      this.setQuantity(this.normalizeQuantity(currentValue) + delta);
    }

    syncQuantityFromSource() {
      if (this.sourceQuantityInput) {
        this.quantityInput.value = this.normalizeQuantity(this.sourceQuantityInput.value);
      }

      this.updateQuantityWidth();
    }

    onQuantityInput() {
      this.updateQuantityWidth();
      if (this.quantityInput.value === '') return;

      this.setQuantity(this.quantityInput.value, false);
    }

    onQuantityChange() {
      this.setQuantity(this.quantityInput.value);
    }

    onSourceQuantityChange() {
      this.syncQuantityFromSource();
    }

    onFormSubmit() {
      this.setQuantity(this.quantityInput.value || (this.sourceQuantityInput && this.sourceQuantityInput.value));
    }

    updateQuantityWidth() {
      const characterCount = Math.max(1, String(this.quantityInput.value || '1').length);
      this.quantityInput.style.width = `${characterCount + 1.1}ch`;
    }

    syncSubmitState() {
      if (!this.sourceSubmitButton) return;

      const disabled = this.sourceSubmitButton.disabled || this.sourceSubmitButton.getAttribute('aria-disabled') === 'true';
      const statusText = this.sourceSubmitButton.textContent.trim();

      this.submitButton.disabled = disabled;
      this.classList.toggle('is-disabled', disabled);

      if (disabled && statusText) {
        this.statusLabel.textContent = statusText;
        this.addLabel.hidden = true;
        this.statusLabel.hidden = false;
      } else {
        this.addLabel.hidden = false;
        this.statusLabel.hidden = true;
      }
    }

    onScroll() {
      if (this.rafId) return;

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.updateVisibility();
      });
    }

    onResize() {
      this.updateVisibility();
    }

    onMediaChange() {
      this.updateVisibility();
    }

    updateVisibility() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const trigger = this.findVisibilityTrigger();
      const barHeight = this.bar.getBoundingClientRect().height;
      const triggerTop = trigger ? trigger.getBoundingClientRect().top + scrollTop : Infinity;
      const shouldShow = !!trigger && this.mediaQuery.matches && scrollTop > 0 && scrollTop + window.innerHeight - barHeight >= triggerTop;
      this.classList.toggle('is-visible', shouldShow);
      this.updatePageState();
    }

    updatePageState() {
      document.documentElement.classList.toggle(
        'mobile-sticky-atc-visible',
        !!document.querySelector('mobile-sticky-atc.is-visible')
      );
    }
  });
}
